export default __webpack_public_path__ + "static/media/lackier_main.b68c5f59.png";